import 'highlight.js/styles/tokyo-night-dark.css';

import hljs from 'highlight.js';

// ----------------------------------------------------------------------

hljs.configure({
  languages: ['javascript', 'jsx', 'sh', 'bash', 'html', 'scss', 'css', 'json']
});

if (typeof window !== 'undefined') {
  window.hljs = hljs;
}
